/**
 * The phone app's words for its frame, its Work tab and its read-only
 * documents (piece 35, *Work and documents*; decision 4201), kept beside the
 * first release's and spread into the one string lookup. A word the web already
 * says, such as My Jobs, On My Way or Subtotal, is read from the web's own key
 * and is not repeated here.
 */
export const WORK_DOCUMENTS_STRINGS = {
  'mobile.tab.crm': 'CRM',
  'mobile.tab.work': 'Work',
  'mobile.tab.documents': 'Documents',
  'mobile.work.unsent': 'The server did not answer, so this may not have been recorded. Check it, then try again once the phone has a signal.',
  'mobile.document.readOnly': 'Read only on the phone. Open it on the web to change, send, approve or pay it.',
  'mobile.document.details': 'Details',
  'mobile.document.totals': 'Totals',
  'mobile.document.billedLabor': 'Billed Labor',
  'mobile.document.noLines': 'No lines.',
} as const;
